/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_CardWithThumbnailsComponent)
});

;// ../../../node_modules/@babel/runtime/helpers/esm/jsx.js
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}

;// ../../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// ../../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ../../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// ../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// ../../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "@andes/thumbnail"
const thumbnail_namespaceObject = require("@andes/thumbnail");
;// external "@andes/card"
const card_namespaceObject = require("@andes/card");
;// external "@andes/icons/ChevronRight16"
const ChevronRight16_namespaceObject = require("@andes/icons/ChevronRight16");
var ChevronRight16_default = /*#__PURE__*/__webpack_require__.n(ChevronRight16_namespaceObject);
;// external "@andes/typography"
const typography_namespaceObject = require("@andes/typography");
;// external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// ./src/constants.js
const Variants = Object.freeze({
  NORMAL: 'normal',
  TINY: 'tiny'
});
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/CardWithThumbnailsComponent.js











const getComponent = (onClick, link) => {
  if (link !== null && link !== void 0 && link.href) {
    return 'a';
  }
  if (onClick) {
    return 'button';
  }
  return 'div';
};
const getLinkProps = (onClick, link) => {
  let attributes = onClick ? {
    onClick
  } : {};
  if (link !== null && link !== void 0 && link.href) {
    attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, attributes), link), {}, {
      rel: 'noreferrer'
    });
  }
  const isClickable = onClick || link;
  const className = external_classnames_default()('card-thumbnail-container', isClickable && 'card-thumbnail-container__clickable', (link === null || link === void 0 ? void 0 : link.href) && 'card-thumbnail-container__redirect-link');
  return _objectSpread2(_objectSpread2({}, attributes), {}, {
    className
  });
};
const CardWithThumbnailsComponent = _ref => {
  let {
    thumbnailContainer,
    title,
    titleSize,
    chevronColor,
    onClick,
    link,
    variant,
    children
  } = _ref;
  const thumbnails = (0,external_react_namespaceObject.useMemo)(() => thumbnailContainer.assets.slice(0, 3).map(asset => /*#__PURE__*/_createRawReactElement(thumbnail_namespaceObject.Thumbnail, {}, "thumbnail-".concat(asset.id), /*#__PURE__*/_createRawReactElement("img", {
    src: asset.src,
    alt: asset.alt
  }))), [thumbnailContainer.assets]);
  const Component = getComponent(onClick, link);
  const redirectLinkProps = getLinkProps(onClick, link);
  const renderChevron = redirectLinkProps.onClick || link;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Component, _objectSpread2(_objectSpread2({
    "data-testid": "card-wrapper"
  }, redirectLinkProps), {}, {
    children: /*#__PURE__*/_createRawReactElement(card_namespaceObject.Card, {
      shadow: "outline"
    }, void 0, /*#__PURE__*/_createRawReactElement(card_namespaceObject.CardContent, {
      className: external_classnames_default()('card-thumbnail-container__content', variant === Variants.TINY && 'card-thumbnail-container__content--tiny')
    }, void 0, /*#__PURE__*/_createRawReactElement(thumbnail_namespaceObject.ThumbnailMultiple, {
      className: external_classnames_default()(thumbnailContainer.type === 'stacked' && 'thumbnail-multiple__base'),
      modifier: thumbnailContainer.modifier,
      containerSize: thumbnailContainer.size,
      type: thumbnailContainer.type,
      overflow: thumbnailContainer.overflow > 0 ? thumbnailContainer.overflow : null
    }, void 0, thumbnails), /*#__PURE__*/_createRawReactElement("div", {
      className: "card-thumbnail-container__body"
    }, void 0, /*#__PURE__*/_createRawReactElement(typography_namespaceObject.Text, {
      className: "card-thumbnail-container__body__title",
      size: titleSize
    }, void 0, title), children), renderChevron && /*#__PURE__*/_createRawReactElement("div", {
      className: "card-thumbnail-container__chevron",
      "data-testid": "chevron"
    }, void 0, /*#__PURE__*/_createRawReactElement((ChevronRight16_default()), {
      color: chevronColor
    }))))
  }));
};
CardWithThumbnailsComponent.defaultProps = {
  href: null,
  thumbnailContainer: {
    type: 'stacked',
    modifier: 'circle',
    overflow: 0,
    size: '24'
  },
  textSize: 's',
  chevronColor: '#2968C8',
  onClick: null,
  variant: Variants.NORMAL,
  children: null
};
/* harmony default export */ const src_CardWithThumbnailsComponent = (CardWithThumbnailsComponent);
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map